import {
  normalizeBrandColor,
  darkenBrandColor,
  readableTextOn,
  nearestReadableColor,
} from './../../shared/utilities/brandColor.function'
import { getSubsiteLogo } from './../../shared/utilities/getSubsiteLogo.function'

const isCoBrandingOn = subsiteData => `${subsiteData?.s_branded}` === '1'

const getAgentLogo = subsiteData => (isCoBrandingOn(subsiteData) ? getSubsiteLogo(subsiteData?.s_logo) : false)

const getBrandingStyle = subsiteData => {
  if (!isCoBrandingOn(subsiteData)) return undefined

  const style = {},
    background = normalizeBrandColor(subsiteData?.s_brand_bg_color),
    accent = normalizeBrandColor(subsiteData?.s_brand_accent_color),
    menu = normalizeBrandColor(subsiteData?.s_brand_menu_color),
    text = normalizeBrandColor(subsiteData?.s_brand_text_color)

  if (background) {
    style['--usabg-blue'] = background
    style['--usabg-blue-dark'] = darkenBrandColor(background)
    style['--usabg-on-blue'] = readableTextOn(background)
    style['--usabg-on-blue-muted'] = readableTextOn(background)
    style['--usabg-header-bg'] = background
    style['--usabg-header-fg'] = readableTextOn(background)
    style['--usabg-header-cta'] = '#e60a00'
    style['--usabg-brand-ink'] = nearestReadableColor(background)
    style['--usabg-menu-bg'] = background
    style['--usabg-on-menu'] = readableTextOn(background)
  }

  if (accent) {
    style['--usabg-red'] = accent
    style['--usabg-red-dark'] = darkenBrandColor(accent)
    style['--usabg-on-red'] = readableTextOn(accent)
    style['--usabg-accent-ink'] = nearestReadableColor(accent)
  }

  if (menu) {
    style['--usabg-menu-bg'] = menu
    style['--usabg-on-menu'] = readableTextOn(menu)
  }

  if (accent) style['--usabg-header-cta'] = accent

  if (text) style['--usabg-charcoal'] = text

  if (background || accent || menu || text) style['--usabg-section-heading'] = text ? text : '#2d2e32'

  return Object.keys(style).length ? style : undefined
}

export { getAgentLogo, getBrandingStyle }
